import React from 'react'

import { StyledInnerElement, RightSideContainer, ToggleOpenButton } from 'components/Tree/nodes/common'

import { ReactComponent as Top } from 'components/Tree/icons/top.svg'

const Floor = ({ index, children, label, isOpened, toggleOpened, isSelectable, handleSelect }) => (
	<li style={{ background: index % 2 === 0 ? 'unset' : '#eee' }}>
		<StyledInnerElement onClick={handleSelect} isSelectable={isSelectable} style={{ paddingLeft: isOpened ? '24px' : '38px' }} noBorder noBackground>
			{isOpened && <Top style={{ marginTop: 'auto', marginRight: '5px' }}/>}
			{label}
			<RightSideContainer>
				<ToggleOpenButton isOpened={isOpened} toggleOpened={toggleOpened}/>
			</RightSideContainer>
		</StyledInnerElement>
		{isOpened && <ul>
			{children}
		</ul>}
	</li>
)

export default Floor
